<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome da Aba"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Nome de Exibição"
              v-model="form.filters.nomeDeExibicao"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.ativo"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarAbas()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterAba()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listAbas"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.nomeDeExibicao`]="{ item }">
          {{ item.nomeDeExibicao }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarAba(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterAba(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Excluir'"
            :icon="'mdi-delete'"
            :small="true"
            @click="excluirAba(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
            :small="true"
            @click="inativarAtivarAba(item)"
          ></sigfoco-tooltip>
        </template>
        <template v-slot:[`item.emUso`]="{ item }">
          <sigfoco-tooltip
            :text="'Detalhar Uso'"
            :icon="item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
            :color="item.emUso ? 'green' : 'red'"
            :small="true"
            :disabled="!item.emUso"
            @click="item.emUso ? openDialogDetalharUsoAba(item) : null"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarAbasDialog
      :visible="dialogManterAba.visible"
      :content="dialogManterAba.content"
      :edit="dialogManterAba.edit"
      @onClose="dialogManterAba.close()"
      @onSave="buscarAbas()"
    ></CadastrarEditarAbasDialog> 
    <VisualizarAbasDialog
      :visible="dialogVisualizarAba.visible"
      :content="dialogVisualizarAba.content"
      @onClose="dialogVisualizarAba.close()"
    ></VisualizarAbasDialog>
     <DetalharUsoAbaDialog
      :visible="dialogDetalharUsoAba.visible"
      :content="dialogDetalharUsoAba.content"
      @onClose="dialogDetalharUsoAba.close()"
      ></DetalharUsoAbaDialog>
  </div>
</template>

<script>
import { Dialog} from "~/commons/classes/dialog";
import { Aba } from "~/commons/classes/aba";
import ManterAbaService from '~/services/manter-aba.service';
import AuthService from '~/services/auth.service';
import CadastrarEditarAbasDialog from "./dialogs/CadastrarEditarAbasDialog.vue";
import VisualizarAbasDialog from "./dialogs/VisualizarAbasDialog.vue";
import DetalharUsoAbaDialog from "./dialogs/DetalharUsoAbaDialog.vue";

export default {
  name: "ManterAbasView",
  mixins: [ManterAbaService, AuthService],
  components: {
    CadastrarEditarAbasDialog,
    VisualizarAbasDialog,
    DetalharUsoAbaDialog
  },
  data: () => ({
    dialogManterAba: Dialog.Build(),
    dialogVisualizarAba: Dialog.Build(),
    dialogDetalharUsoAba: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        ativo: null,
      },
      lists: {
        listAbas: []
      }
    },
    headers: [
      { text: "Nome da Aba", align: "center", value: "nome" },
      { text: "Nome de Exibição", align: "center", value: "nomeDeExibicao" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
      { text: "Em uso", align: "center", value: "emUso", sortable: false },

    ]
  }),
  methods: {
    openDialogManterAba(aba) {
      aba
        ? this.$visualizarAbas(aba).then(({ data }) => {
            this.dialogManterAba.open(new Aba(data.resposta.grupo).format(), true);
          })
        : this.dialogManterAba.open(Aba.Build());
    },
    openDialogVisualizarAba(aba) {
      this.$visualizarAbas(aba).then(
        ({ data }) => (this.dialogVisualizarAba.open(data.resposta.grupo))
      );
    },
    buscarAbas() {
      this.$buscarAbas({ params: this.form.filters }).then(
        ({ data }) => (this.form.lists.listAbas = data.grupos)
      );
    },
    inativarAtivarAba(aba) {
      this.$swal({
        text: `Deseja confirmar a ${
          aba.ativo ? "inativação" : "ativação"
        } da Aba?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
      if (aba.ativo && aba.emUso) {
          this.mostrarModalEmUso(aba);
        } else {
          this.$inativarAtivarAba({id:aba.id} , aba.id)
            .then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarAbas();
            });
        }
      });
    },
    excluirAba(aba) {
      this.$swal({
        text: `Deseja confirmar a exclusão da aba?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
      if (aba.emUso) {
          this.mostrarModalEmUso(aba);
        } else {
          this.$excluirAba({id: aba.id}, aba.id)
            .then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarAbas();
            });
        }
      });
    },
    mostrarModalEmUso(item) {
      const qtd = item.quantidadeEmUso;
      this.$swal({
        text: `O registro não pode ser inativado ou excluído, pois está em uso em ${qtd} funcionalidade(s).`,
        type: "warning",
        confirmButtonText: "OK",
      });
    },
    openDialogDetalharUsoAba(aba) {
      this.$detalharUsoAba(aba).then(
        ({ data }) => (this.dialogDetalharUsoAba.open(data.resposta))
      );
    },  
    resetForm() {
      this.$resetForm();
      this.form.filters.ativo = null;
      this.form.lists.listAbas = [];
    },
  }
};
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>